import PageSidebar from './component'

export default PageSidebar
